import React from "react";

const Admin_Dashboard = () => {
  return <div>Admin_Dashboard</div>;
};

export default Admin_Dashboard;
